var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    className: "search_svg__feather search_svg__feather-search"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21 21-4.35-4.35"
  })));
};
export default SvgSearch;